import React, { Component } from 'react';

class ErrorGuardadoGlobal extends Component {
    render() { 
        const {mensaje} = this.props;
        return (  
        <div className='modalErrorGlobalInterior'>
            {!mensaje ? <div>"Hubo un error en la comunicación con la procesadora, por favor intente nuevamente más tarde"</div> : <div>{mensaje}</div>}
            <div className='footerTelefonosModal'>
                <button onClick={()=>this.props.funcionAceptar()} className='btn btn-cta'>Aceptar</button>
            </div>
        </div>
       );
    }   
}
export default ErrorGuardadoGlobal;